import { convertDateToIsoDateStr, getFutureDate } from './date_utils';
/**
 * Gets a LocalStorage item value by key
 * If the item has expired, it will be removed and null will be returned
 */
var getLocalStorageItemValue = function (key) {
    var itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    var item = JSON.parse(itemStr);
    var now = new Date();
    if (item.expiry && now.getTime() > new Date(item.expiry).getTime()) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
/**
 * Sets a LocalStorage item with a key and value and optional expiration based on expireDays
 */
var setLocalStorageItem = function (key, value, expireDays) {
    var itemValue = {
        value: value,
        expiry: expireDays ? convertDateToIsoDateStr(getFutureDate(new Date(), expireDays)) : null,
    };
    localStorage.setItem(key, JSON.stringify(itemValue));
};
export { getLocalStorageItemValue, setLocalStorageItem };
